const CACHE = new WeakMap();

export function getByType(Type) {
    return CACHE.has(Type) ? CACHE.get(Type) : null;
}

export function get(component) {
    const {type: Type} = component;

    return getByType(Type);
}

export function set(Type, props) {
    if (CACHE.has(Type)) {
        Object.assign(props, CACHE.get(Type), props);
    }

    CACHE.set(Type, props);
}
